<template>
  <div class="full-height">
    <div
      v-if="buttons.length > 0 && !rowButtons"
      class="q-px-md q-pb-md q-gutter-sm full-width text-right"
    >
      <span v-for="(button, index) in buttons" :key="index">
        <q-btn
          color="secondary"
          :disable="!filterButton(button)"
          v-if="filterButton(button, null, true)"
          @click="actionButtonValidate(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </span>
    </div>
    <jt-data-table
      ref="table"
      class="jt-datatable no-shadow table_header"
      v-bind="$props"
      @selection="selectionHandler"
      @action-button="onActionButtonHandler2"
    >
    </jt-data-table>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtEmptyMessage } from 'jtech-webcomps'

@Component({
  name: 'vehicleDwellTimeTable',
  components: { JtEmptyMessage, JtDataTable },
  mixins: [JtDataTable]
})
class VehicleDwellTimeTable extends Vue {
  selectionHandler (value) {
    if (value.length) this.$emit('selection', value)
  }

  availableStyle ({ col, props }) {
    return col.model === 'available'
      ? props.row[col.model]
        ? 'no-padding text-positive text-bold'
        : 'no-padding text-red text-bold'
      : 'no-padding '
  }

  async onActionButtonHandler2 (button, params, context) {
    await this.onActionButtonHandler(button, params, this)
  }

  refresh () {
    this.$refs.table.refresh()
  }
}
export default VehicleDwellTimeTable
</script>
